/**
 * Labstep
 *
 * @module components/Group/Template
 * @desc Group Templatable Entity
 */

import { GroupTemplateEmptyState } from 'labstep-web/components/Group/Template/EmptyState';
import { MetadataManagerContainer as MetadataManager } from 'labstep-web/components/Metadata/Manager';
import { ReadOnMountHOC } from 'labstep-web/hoc/ReadOnMount';
import type React from 'react';
import type { GroupTemplateProps } from './types';

export const GroupTemplate: React.FC<GroupTemplateProps> = ({
  group,
  field,
  entityName,
  extraRows,
  options,
  extraBody,
}) => {
  const id = group[field];
  if (!id) {
    return (
      <GroupTemplateEmptyState
        group={group}
        entityName={entityName}
        options={options}
        extraBody={extraBody}
      />
    );
  }
  return (
    <ReadOnMountHOC
      type="entities"
      entityName={entityName}
      params={{ id, get_single: 1 }}
      loading={{ loader: 'placeholder', cached: true }}
      children={({ entity }) => (
        <MetadataManager
          isTemplate
          entity={entity}
          extraRows={extraRows}
        />
      )}
    />
  );
};
